import { InjectionToken } from '@angular/core';
import { Features } from './feature.constant';
import { IFeatureMap } from './feature.interfaces';

export const HardcodedFeatures: IFeatureMap[] = [
  {
    id: Features.QqcTripTypeId,
    name: 'QQC Trip Type Selector',
    enabled: [
      {
        brands: ['wn'],
        value: false,
      },
    ],
  },
  {
    id: Features.RewardPointsId,
    name: 'Reward Points',
    enabled: [
      {
        brands: ['tidau'],
        value: false,
      },
    ],
  },
  {
    id: Features.EmailQuoteId,
    name: 'Email Quote',
    enabled: [
      {
        brands: ['sv'],
        value: false,
      },
    ],
  },
  {
    id: Features.QqcPrivateInsuranceId,
    name: 'QQC Private Medical Insurance',
    enabled: [
      {
        brands: ['nibau', 'tidau', 'nsi', 'cota', 'qan'],
        value: false,
      },
    ],
  },
  {
    id: Features.FootprintsId,
    name: 'Footprints',
    enabled: [
      {
        value: false,
      },
      {
        brands: ['tidau'],
        value: true,
      },
    ],
  },
  {
    id: Features.UserRegistrationId,
    name: 'User Registration',
    enabled: [
      {
        value: false,
      },
      {
        brands: ['tidau'],
        value: true,
      },
    ],
  },
  {
    id: Features.WinterSportTermsId,
    name: 'Winter Sport Terms & Conditions',
    enabled: [
      {
        brands: ['tidau'],
        value: false,
      },
    ],
  },
  {
    id: Features.CookiesAlertId,
    name: 'Cookies alert',
    enabled: [
      {
        brands: ['tidau'],
        value: false,
      },
    ],
  },
  {
    id: Features.PromoCodeId,
    name: 'Promo Code',
    enabled: [{ brands: ['sv'], value: false }],
  },
];

export const APP_FEATURES = new InjectionToken('App Features', {
  providedIn: 'root',
  factory: () => HardcodedFeatures,
});
